import React from 'react';
import { useParams } from 'react-router-dom';
import { DRCApprovalContent } from '../../../Assessment';
import { PAGE_COMMON_TEXT } from '../lang';
import { waitingForProcessing } from '../WaitProcess';
import { Loading, Alert } from '../../../../components';
import { useGetDsrcApproval } from '../../../Assessment/graphql';

export const DSRCApprovalForm: React.FunctionComponent = () => {
  const { applicationId = '' } = useParams();

  const { dsrcApprovalCreated, dsrcApproval, drcRequired, loading, error } =
    useGetDsrcApproval(applicationId);

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : dsrcApprovalCreated && drcRequired ? (
        <DRCApprovalContent
          hasDsrcApprovalCreated={dsrcApprovalCreated}
          isViewMode={true}
          dsrcApproval={dsrcApproval}
          drcRequired={drcRequired}
        />
      ) : (
        waitingForProcessing(PAGE_COMMON_TEXT.SIDEBAR_TEXT.DRC_APPROVAL)
      )}
    </>
  );
};
